module.exports = __webpack_public_path__ + "static/media/connect.aca50952.webp";